import { BubbleShapeEnum } from '@/enum/BubbleShapeEnum';

// Morph-like paths (Treasure Planet): soft goo, squash/stretch, drip —
// all M + 12×C + Z, viewBox "-100 -100 200 200", fully convex.
// prettier-ignore
export enum SHAPES {
  // Au repos : fantôme — large en haut (cape), fin en bas (train effilé)
  IDLE =
    'M4.6,-82.2'
    + ' C36.8,-84.6,74.2,-70.4,82.8,-44.2'
    + ' C90.6,-20.4,86.4,6.2,74.2,28.4'
    + ' C60.8,52.6,38.2,72.8,10.4,84.6'
    + ' C2.4,88.2,-2.4,88.2,-10.4,84.6'
    + ' C-38.2,72.8,-60.8,52.6,-74.2,28.4'
    + ' C-86.4,6.2,-90.6,-20.4,-82.8,-44.2'
    + ' C-74.2,-70.4,-36.8,-84.6,4.6,-82.2Z',
  // Squash : s'écrase en largeur, comme Morph excité / atterrit
  SQUEEZING =
    'M8.2,-48.6'
    + ' C26.4,-52.1,52.8,-46.8,71.4,-32.4'
    + ' C90.2,-17.6,98.6,6.2,94.1,26.8'
    + ' C89.8,46.4,72.2,60.2,51.6,66.4'
    + ' C31.8,72.2,8.4,70.8,-12.6,64.2'
    + ' C-33.8,57.4,-52.4,45.2,-64.2,28.6'
    + ' C-76.4,11.6,-81.2,-10.4,-74.8,-29.2'
    + ' C-68.6,-47.4,-50.2,-58.8,-30.4,-61.6'
    + ' C-11.2,-64.2,-8.6,-45.2,8.2,-48.6Z',
  // Posé : plus rond, compact, « content »
  SETTLED =
    'M6.8,-64.2'
    + ' C24.2,-68.4,46.8,-62.8,61.4,-49.2'
    + ' C76.2,-35.4,84.6,-15.2,82.8,4.6'
    + ' C81.1,23.8,70.4,41.2,54.2,52.6'
    + ' C38.6,63.6,18.2,68.8,-2.4,68.2'
    + ' C-23.2,67.6,-43.1,59.4,-56.8,45.2'
    + ' C-70.8,30.6,-78.2,10.4,-75.4,-9.6'
    + ' C-72.6,-29.2,-59.4,-46.8,-41.2,-56.4'
    + ' C-23.8,-65.6,-11.2,-60.2,6.8,-64.2Z',
  // Drip : goutte qui s'étire vers le bas
  DRIPPING =
    'M4.2,-78.4'
    + ' C22.6,-82.1,44.8,-74.6,58.2,-58.4'
    + ' C72.1,-41.6,78.4,-18.2,74.6,2.8'
    + ' C71.2,21.4,58.6,36.8,42.4,48.6'
    + ' C27.2,59.4,8.6,68.2,-6.4,78.8'
    + ' C-18.2,87.2,-24.6,92.4,-28.8,88.6'
    + ' C-34.2,83.6,-32.4,68.2,-42.6,52.4'
    + ' C-54.8,33.6,-72.4,16.2,-76.8,-6.4'
    + ' C-81.4,-29.8,-70.2,-54.2,-50.6,-67.8'
    + ' C-31.8,-80.8,-14.2,-74.8,4.2,-78.4Z',
  // Transition : blob intermédiaire arrondi (voyage entre plateformes, sans pointe)
  TRANSITION =
    'M2.4,-68.4'
    + ' C32.6,-72.8,64.2,-62.4,72.8,-40.6'
    + ' C80.4,-20.2,78.6,2.8,68.4,24.6'
    + ' C56.8,48.2,34.6,64.8,8.4,72.4'
    + ' C-2.2,75.8,-2.2,75.8,-8.4,72.4'
    + ' C-34.6,64.8,-56.8,48.2,-68.4,24.6'
    + ' C-78.6,2.8,-80.4,-20.2,-72.8,-40.6'
    + ' C-64.2,-62.4,-32.6,-72.8,2.4,-68.4Z',
  // Intermédiaires idle : gonflement avant squash
  PUFFY =
    'M5.2,-72.4'
    + ' C34.2,-78.8,70.8,-66.2,78.4,-42.6'
    + ' C88.2,-18.4,84.6,8.4,72.4,30.2'
    + ' C58.6,54.8,36.4,68.2,12.2,78.4'
    + ' C4.8,82.2,-4.2,82.2,-12.4,78.4'
    + ' C-40.2,66.8,-62.4,50.2,-76.8,26.8'
    + ' C-88.4,4.6,-92.2,-22.4,-84.6,-44.8'
    + ' C-76.2,-68.2,-38.4,-80.6,5.2,-72.4Z',
  // Balancement entre squash et goutte
  WOBBLE =
    'M6.4,-58.2'
    + ' C28.4,-54.8,54.6,-52.4,68.2,-38.6'
    + ' C86.4,-22.8,92.8,2.4,88.6,24.8'
    + ' C84.2,46.6,68.4,62.4,48.2,70.2'
    + ' C28.6,77.8,6.2,76.4,-14.8,68.6'
    + ' C-38.2,60.2,-58.6,46.8,-70.4,28.4'
    + ' C-82.6,9.6,-86.4,-14.2,-80.2,-36.8'
    + ' C-74.8,-56.4,-52.6,-64.8,6.4,-58.2Z',
  // Rebond après la goutte
  REBOUND =
    'M5.4,-70.2'
    + ' C26.8,-74.6,50.4,-68.4,64.2,-54.2'
    + ' C78.4,-39.6,84.2,-18.8,82.4,2.2'
    + ' C80.6,22.4,70.2,40.8,54.6,54.2'
    + ' C40.2,66.4,20.8,72.6,0.2,72.4'
    + ' C-20.8,72.2,-40.4,64.8,-54.2,50.6'
    + ' C-68.6,35.8,-76.4,16.2,-74.8,-4.8'
    + ' C-73.2,-24.8,-62.4,-44.2,5.4,-70.2Z',
  // Expansion douce avant retour au repos
  SWELL =
    'M5.8,-74.6'
    + ' C30.4,-78.2,62.8,-68.4,74.2,-48.6'
    + ' C86.4,-26.8,84.8,-2.4,74.6,20.2'
    + ' C62.4,44.8,40.2,64.2,14.6,76.8'
    + ' C6.2,80.4,-6.2,80.4,-14.6,76.8'
    + ' C-40.2,64.2,-62.4,44.8,-74.6,20.2'
    + ' C-84.8,-2.4,-86.4,-26.8,-74.2,-48.6'
    + ' C-62.8,-68.4,-30.4,-78.2,5.8,-74.6Z',
}

// prettier-ignore
const BLOB_SHAPES: Record<BubbleShapeEnum, string> = {
  [BubbleShapeEnum.SHAPE_1]:
    'M-92.59-88.163C-82.848-94.668-45.024-100.491-6.911-99.967'
    + 'C29.811-99.462,66.804-92.814,79.209-88.163'
    + 'C101.117-79.951,102.046-38.682,98.323,5.037'
    + 'C95.126,42.599,89.506,83.004,79.209,93.93'
    + 'C67.786,106.05,30.352,96.306-6.911,96.12'
    + 'C-44.882,95.93-74.484,105.079-84.398,93.93'
    + 'C-95.798,81.11-91.11,45.358-92.59,8.821'
    + 'C-94.319-33.841-108.362-77.634-92.59-88.163Z',
  [BubbleShapeEnum.SHAPE_2]:
    'M-92.59-88.164C-82.848-94.668-45.025-100.491-6.911-99.967'
    + 'C29.811-99.462,66.803-92.814,79.209-88.164'
    + 'C101.117-79.951,102.045-38.682,98.324,5.038'
    + 'C95.126,42.598,89.506,83.004,79.209,93.93'
    + 'C67.786,106.051,30.353,96.306-6.911,96.12'
    + 'C-44.882,95.93-74.485,105.079-84.398,93.93'
    + 'C-95.798,81.11-91.11,45.357-92.59,8.821'
    + 'C-94.319-33.841-108.362-77.634-92.59-88.164Z',
  [BubbleShapeEnum.SHAPE_3]:
    'M5.568-94.501C-33.863-95.047-72.993-104.304-83.072-97.534'
    + 'C-99.389-86.575-101.237-38.31-99.449,6.092'
    + 'C-97.917,44.116-94.866,78.638-83.072,91.981'
    + 'C-72.817,103.584-33.716,94.062,5.568,94.26'
    + 'C44.119,94.454,81.893,108.469,94.664,91.981'
    + 'C107.434,75.493,92.391,31.344,98.993-42.731'
    + 'C100.944-81.042,94.664-87.479,84.489-94.501'
    + 'C73.012-102.422,43.559-93.975,5.568-94.501Z',
  [BubbleShapeEnum.SHAPE_4]:
    'M5.568-94.501C-33.863-95.047-72.993-104.304-83.072-97.534'
    + 'C-99.389-86.575-101.237-38.31-99.449,6.092'
    + 'C-97.917,44.116-94.866,78.638-83.072,91.981'
    + 'C-72.817,103.584-33.716,94.062,5.568,94.259'
    + 'C44.119,94.454,81.894,108.469,94.664,91.981'
    + 'C107.434,75.493,92.391,31.344,98.993-42.732'
    + 'C100.944-81.042,94.664-87.48,84.49-94.501'
    + 'C73.012-102.422,43.559-93.975,5.568-94.501Z',
  [BubbleShapeEnum.SHAPE_5]:
    'M-80.883-87.673C-63.327-101.88,47.344-106.197,76.363-87.673'
    + 'C110.745-65.727,104.876,63.239,76.363,86.312'
    + 'C52.356,105.739-59.832,103.347-80.883,86.312'
    + 'C-106.013,65.977-106.729-66.758-80.883-87.673Z',
  [BubbleShapeEnum.SHAPE_6]:
    'M-91.608-95.288C-81.865-101.793-42.814-99.263-4.7-98.739'
    + 'C32.022-98.233,74.42-99.447,86.825-94.797'
    + 'C108.733-86.584,90.991-49.984,89.48-2.579'
    + 'C88.279,35.099,102.281,83.495,91.984,94.422'
    + 'C80.562,106.542,30.598,98.517-6.665,98.331'
    + 'C-44.637,98.141-82.592,104.342-92.505,93.193'
    + 'C-103.905,80.373-90.864,41.918-92.345,5.382'
    + 'C-94.073-37.281-107.379-84.758-91.608-95.288Z',
  [BubbleShapeEnum.SHAPE_7]:
    'M6.68-99.342C32.916-96.746,59.649-76.083,77.009-54.571'
    + 'C95.324-31.874,105.418-0.064,96.987,28.689'
    + 'C89.119,55.523,61.78,78.489,38.275,90.406'
    + 'C15.311,102.05-8.242,102.8-32.335,94.257'
    + 'C-60.367,84.317-83.811,61.434-92.961,31.001'
    + 'C-103.186-3.009-104.464-44.311-81.805-70.288'
    + 'C-60.276-94.969-24.503-102.428,6.68-99.342Z',
  [BubbleShapeEnum.SHAPE_8]:
    'M4.888-99.948C34.204-101.113,60.125-82.547,78.116-59.204'
    + 'C95.788-36.277,103.942-7.373,98.158,21.062'
    + 'C92.207,50.32,74.323,76.034,47.866,89.515'
    + 'C20.772,103.321-10.959,103.226-38.706,90.804'
    + 'C-67.61,77.864-94.436,55.06-99.387,23.592'
    + 'C-104.084-6.262-80.873-30.629-61.435-53.658'
    + 'C-43.106-75.373-23.387-98.824,4.888-99.948Z',
  [BubbleShapeEnum.SHAPE_9]:
    'M-5.92-97.56C22.802-98.745,54.582-106.993,75.203-84.427'
    + 'C98.043-59.433,104.675-19.86,96.869,14.925'
    + 'C89.262,48.825,64.775,73.357,36.542,87.857'
    + 'C9.143,101.928-22.382,105.208-49.294,89.989'
    + 'C-75.722,75.044-91.569,44.688-97.519,12.046'
    + 'C-103.295-19.637-99.598-54.48-79.921-78.025'
    + 'C-61.646-99.893-32.557-96.46-5.92-97.56Z',
  [BubbleShapeEnum.SHAPE_10]:
    'M4.082-99.826C35.28-101.224,69.126-94.489,87.89-68.481'
    + 'C106.226-43.067,100.441-8.488,92.037,22.078'
    + 'C84.334,50.09,69.483,75.535,44.625,88.883'
    + 'C18.912,102.689-11.195,103.606-37.809,91.8'
    + 'C-66.129,79.237-91.451,56.777-98.26,25.499'
    + 'C-105.06-5.737-91.072-36.961-71.151-61.356'
    + 'C-52.105-84.679-25.281-98.511,4.082-99.826Z',
};

export const PLATFORM_SELECTOR = '[data-blob-shape], [data-bubble-anchor]';
export const MIN_VISIBILITY_RATIO = 0.1;
/** Bande verticale centrée : un blob focus s'il intersecte cette zone (largeur = tout l'écran). */
export const FOCUS_ZONE_HEIGHT_RATIO = 0.55;
/** Au-delà de cette fraction de la hauteur utile (axe Y), on defocus. */
export const FOCUS_MAX_VERTICAL_RATIO = 0.32;
export const IDLE_SIZE = 'min(420px, 52vw)';
export const TRAVEL_DURATION = 2.1;
export const DEFOCUS_DURATION = 1.6;

/** Rayon d'influence voisin = facteur × (demi-largeur main + demi-largeur voisin). */
export const NEIGHBOR_INFLUENCE_RADIUS = 1.2;
export const REPULSE_STRENGTH = 48;
export const SQUEEZE_STRENGTH = 0.35;
/** Seuil au-delà duquel un blob unique est considéré hors focus (progress → 1). */
export const SINGLE_BLOB_IDLE_RATIO = 1;

export const COMPANION_CONFIG = [
  {
    offsetX: -0.55,
    offsetY: -0.28,
    lag: 0.08,
    scale: 0.17,
    repulsionWeight: 1,
    squeezeWeight: 0.9,
    wobblePhase: 2.1,
    wobbleFreq: 1.4,
    wobbleHarmonic: 1.9,
    opacity: 0.5,
  },
  {
    offsetX: 0.48,
    offsetY: -0.24,
    lag: 0.095,
    scale: 0.14,
    repulsionWeight: 0.85,
    squeezeWeight: 0.75,
    wobblePhase: 3.8,
    wobbleFreq: 1.7,
    wobbleHarmonic: 2.2,
    opacity: 0.58,
  },
  {
    offsetX: -0.1,
    offsetY: 0.5,
    lag: 0.12,
    scale: 0.11,
    repulsionWeight: 0.7,
    squeezeWeight: 0.6,
    wobblePhase: 1.3,
    wobbleFreq: 2.1,
    wobbleHarmonic: 1.6,
    opacity: 0.66,
  },
] as const;

export type PlatformTarget = {
  element: HTMLElement;
  rect: DOMRect;
  shapePath: string;
  /** Distance verticale au centre utile. */
  distance: number;
};

export function getVerticalDistance(rect: DOMRect, centerY: number): number {
  return Math.abs(rect.top + rect.height / 2 - centerY);
}

export function getBlobShapePath(shapeAttr: string | null | undefined): string | undefined {
  if (!shapeAttr) return undefined;
  return BLOB_SHAPES[shapeAttr as BubbleShapeEnum];
}

export function getShapeName(shape: SHAPES): keyof typeof SHAPES {
  const key = (Object.keys(SHAPES) as (keyof typeof SHAPES)[]).find((k) => SHAPES[k] === shape);
  return key ?? 'IDLE';
}

export type ViewportCenter = {
  x: number;
  y: number;
  /** Bas du header fixe (px depuis le haut du viewport). */
  headerBottom: number;
};

/** Centre du viewport utile, sous le header fixe. */
export function getViewportCenter(): ViewportCenter {
  const header = document.querySelector('header');
  const headerBottom = header?.getBoundingClientRect().bottom ?? 0;
  const contentHeight = Math.max(0, window.innerHeight - headerBottom);

  return {
    x: window.innerWidth / 2,
    y: headerBottom + contentHeight / 2,
    headerBottom,
  };
}

/** Le blob intersecte la bande verticale centrée (pas de contrainte horizontale). */
export function isInFocusZone(rect: DOMRect, center: ViewportCenter = getViewportCenter()): boolean {
  const contentHeight = Math.max(0, window.innerHeight - center.headerBottom);
  const zoneHalfHeight = (contentHeight * FOCUS_ZONE_HEIGHT_RATIO) / 2;
  const zoneTop = center.y - zoneHalfHeight;
  const zoneBottom = center.y + zoneHalfHeight;

  return rect.bottom >= zoneTop && rect.top <= zoneBottom;
}

export function getFocusMaxVerticalDistance(center: ViewportCenter = getViewportCenter()): number {
  const contentHeight = Math.max(0, window.innerHeight - center.headerBottom);
  return contentHeight * FOCUS_MAX_VERTICAL_RATIO;
}

function isVisibleEnough(rect: DOMRect, headerBottom: number): boolean {
  if (rect.width < 12 || rect.height < 12) return false;

  // Marge verticale large : on garde les plateformes bientôt visibles pour le blend
  const margin = window.innerHeight * 0.85;
  if (rect.bottom < headerBottom - margin || rect.top > window.innerHeight + margin) {
    return false;
  }

  return true;
}

/** Collecte les blobs statiques visibles, sans doublons ancêtre/descendant. */
export function collectPlatforms(): PlatformTarget[] {
  const nodes = Array.from(document.querySelectorAll<HTMLElement>(PLATFORM_SELECTOR));
  const filtered = nodes.filter(
    (el) => !nodes.some((other) => other !== el && other.contains(el)),
  );

  const { y: centerY, headerBottom } = getViewportCenter();

  return filtered
    .map((element) => {
      const rect = element.getBoundingClientRect();
      if (!isVisibleEnough(rect, headerBottom)) return null;

      const shapeAttr = element.getAttribute('data-blob-shape');
      const shapePath = getBlobShapePath(shapeAttr) ?? SHAPES.IDLE;
      const distance = getVerticalDistance(rect, centerY);

      return { element, rect, shapePath, distance };
    })
    .filter((p): p is PlatformTarget => p !== null)
    .sort((a, b) => a.distance - b.distance);
}

/** Plateforme la plus proche verticalement du centre (escalier gauche/droite).
 * Si au moins une plateforme porte `data-bubble-anchor` (carousel / guide-souris),
 * on ne considère que ces ancres — sinon tous les `data-blob-shape`.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- reserved for sticky selection
export function pickBestPlatform(_current: HTMLElement | null = null): PlatformTarget | null {
  const center = getViewportCenter();
  const maxVerticalDistance = getFocusMaxVerticalDistance(center);
  const platforms = collectPlatforms();

  const anchors = platforms.filter((p) => p.element.hasAttribute('data-bubble-anchor'));
  const pool = anchors.length > 0 ? anchors : platforms;
  const inZone = pool.filter((p) => isInFocusZone(p.rect, center));
  const closest = inZone[0] ?? null;
  if (!closest || closest.distance > maxVerticalDistance) return null;
  return closest;
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function clamp(value: number, min = 0, max = 1): number {
  return Math.min(max, Math.max(min, value));
}

/** Rotation CSS (deg) d'un élément — 0 si pas de transform. */
export function getElementRotationDeg(element: HTMLElement): number {
  const { transform } = window.getComputedStyle(element);
  if (!transform || transform === 'none') return 0;
  const { a, b } = new DOMMatrixReadOnly(transform);
  const angle = Math.atan2(b, a) * (180 / Math.PI);
  return Math.abs(angle) < 0.01 ? 0 : angle;
}

/** Centre Y viewport d'une plateforme (rect déjà en coords viewport). */
export function getPlatformCenterY(platform: PlatformTarget): number {
  return platform.rect.top + platform.rect.height / 2;
}

/** Centre X viewport d'une plateforme. */
export function getPlatformCenterX(platform: PlatformTarget): number {
  return platform.rect.left + platform.rect.width / 2;
}

/** Trie les plateformes du haut vers le bas (par centre Y viewport). */
export function sortPlatformsByDocumentY(platforms: PlatformTarget[]): PlatformTarget[] {
  return [...platforms].sort((a, b) => getPlatformCenterY(a) - getPlatformCenterY(b));
}

export type ScrollBlendState = {
  from: PlatformTarget | null;
  to: PlatformTarget | null;
  /** 0 = sur `from`, 1 = sur `to`. */
  progress: number;
  /** true quand aucun blob n'est dans la zone (idle pur). */
  isIdle: boolean;
};

/**
 * Calcule le segment [from, to] et le progress de blend selon le centre viewport.
 * Les plateformes doivent être en coords viewport (getBoundingClientRect).
 */
export function getScrollBlendState(
  platforms: PlatformTarget[],
  center: ViewportCenter = getViewportCenter(),
): ScrollBlendState {
  const sorted = sortPlatformsByDocumentY(platforms);

  if (sorted.length === 0) {
    return { from: null, to: null, progress: 0, isIdle: true };
  }

  const maxDist = getFocusMaxVerticalDistance(center);

  if (sorted.length === 1) {
    const only = sorted[0];
    const dist = Math.abs(getPlatformCenterY(only) - center.y);
    if (dist > maxDist * SINGLE_BLOB_IDLE_RATIO && !isInFocusZone(only.rect, center)) {
      return { from: null, to: null, progress: 0, isIdle: true };
    }
    const progress = clamp(dist / Math.max(maxDist, 1));
    return { from: only, to: null, progress, isIdle: false };
  }

  const centers = sorted.map(getPlatformCenterY);

  if (center.y < centers[0]) {
    const dist = centers[0] - center.y;
    if (dist > maxDist && !isInFocusZone(sorted[0].rect, center)) {
      return { from: null, to: sorted[0], progress: 0, isIdle: true };
    }
    return { from: null, to: sorted[0], progress: clamp(1 - dist / Math.max(maxDist, 1)), isIdle: false };
  }

  const lastIdx = sorted.length - 1;
  if (center.y > centers[lastIdx]) {
    const dist = center.y - centers[lastIdx];
    if (dist > maxDist && !isInFocusZone(sorted[lastIdx].rect, center)) {
      return { from: sorted[lastIdx], to: null, progress: 1, isIdle: true };
    }
    return {
      from: sorted[lastIdx],
      to: null,
      progress: clamp(dist / Math.max(maxDist, 1)),
      isIdle: false,
    };
  }

  for (let i = 0; i < lastIdx; i += 1) {
    if (center.y >= centers[i] && center.y <= centers[i + 1]) {
      const span = centers[i + 1] - centers[i];
      const progress = span <= 0 ? 0 : clamp((center.y - centers[i]) / span);
      return { from: sorted[i], to: sorted[i + 1], progress, isIdle: false };
    }
  }

  return { from: sorted[lastIdx], to: null, progress: 1, isIdle: false };
}

export type NeighborInfluence = {
  repulseX: number;
  repulseY: number;
  /** 0 = aucun, ~1 = max. */
  squeeze: number;
};

/**
 * Calcule repoussement + squeeze dus aux blobs voisins (hors from/to actifs).
 * Coords viewport.
 */
export function computeNeighborInfluence(
  mainCx: number,
  mainCy: number,
  mainRadius: number,
  platforms: PlatformTarget[],
  excludeElements: HTMLElement[] = [],
): NeighborInfluence {
  let repulseX = 0;
  let repulseY = 0;
  let squeeze = 0;

  const exclude = new Set(excludeElements);

  platforms.forEach((platform) => {
    if (exclude.has(platform.element)) return;

    const nx = getPlatformCenterX(platform);
    const ny = getPlatformCenterY(platform);
    const neighborRadius = Math.max(platform.rect.width, platform.rect.height) / 2;
    const influenceRadius = (mainRadius + neighborRadius) * NEIGHBOR_INFLUENCE_RADIUS;

    const dx = mainCx - nx;
    const dy = mainCy - ny;
    const d = Math.hypot(dx, dy);
    if (d >= influenceRadius || d < 1e-6) return;

    const strength = 1 - d / influenceRadius;
    const inv = 1 / d;
    repulseX += dx * inv * strength * REPULSE_STRENGTH;
    repulseY += dy * inv * strength * REPULSE_STRENGTH;
    squeeze += strength * SQUEEZE_STRENGTH;
  });

  return {
    repulseX,
    repulseY,
    squeeze: clamp(squeeze, 0, 1),
  };
}
